import { LayoutControlType, PluginHelper, findInLayoutCell, } from "@plansoft-configuration-renderer/layout";
import { getSubstructureLayoutPropsWithFallback, } from "../../Controls/Substructure";
/**
 * Retrieve the nested substructure layout properties from the given cell.
 *
 * ⚠️ Disclaimer
 * - Should be used on an attribute cell
 * - Applying this to any other cell will either get you random substructure cell properties or nothing at all
 * @param cell
 * @returns
 */
export function getNestedSubstructureLayoutProps(cell) {
    if (!cell) {
        return undefined;
    }
    const controlCells = findInLayoutCell(cell, (el) => PluginHelper.getPluginId(el) === LayoutControlType.Substructure);
    if (controlCells.length === 0) {
        return undefined;
    }
    const pluginProps = PluginHelper.getPluginProps(controlCells[0]);
    return getSubstructureLayoutPropsWithFallback(pluginProps);
}
/**
 * Same as {@link getNestedSubstructureLayoutProps} but with a fallback to default properties.
 * @param cell
 * @returns
 */
export function getNestedSubstructureLayoutPropsWithFallback(cell) {
    var _a;
    return ((_a = getNestedSubstructureLayoutProps(cell)) !== null && _a !== void 0 ? _a : getSubstructureLayoutPropsWithFallback({}));
}
//# sourceMappingURL=getNestedSubstructureLayoutProps.js.map